/* Aria cart 2026-09-19.2: one cart owner, native form data, recoverable errors. */
(function () {
  'use strict';
  if (window.ACDCart && window.ACDCart.version === '2026-09-19.2') return;
  var drawer = document.getElementById('advanced-cart-drawer');
  if (!drawer) return;
  // This asset is deferred BEFORE theme.js. Keep Impulse's variant/image code,
  // but do not initialise its second drawer or its failure-prone AjaxProduct.
  if (window.theme && window.theme.settings) window.theme.settings.cartType = 'aria-drawer';
  var items = document.getElementById('acd-items');
  var footer = document.getElementById('acd-footer');
  var errorBox = document.getElementById('acd-error');
  var closeButton = document.getElementById('acd-close-btn');
  var panel = drawer.querySelector('.acd-drawer');
  var latest = null, revision = 0, busy = false, returnFocus = null, oldOverflow = '';
  var bound = new WeakSet(), pending = new WeakSet(), compare = new Map(), optionMeta = new Map();
  var timer = null, timerEnd = 0, currency = 'AUD';
  var uncertain = "We couldn't confirm whether your item was added. Please check your cart before trying again.";
  function route(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return root.replace(/\/?$/, '/') + path;
  }
  function node(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = String(text);
    return el;
  }
  function money(cents) {
    if (currency === 'AUD') return '$' + (Number(cents) / 100).toFixed(2);
    return new Intl.NumberFormat('en-AU', {style: 'currency', currency: currency}).format(Number(cents) / 100);
  }
  function localUrl(value, fallback) {
    try { var u = new URL(value, location.origin); if (u.origin === location.origin) return u.href; } catch (e) {}
    return fallback;
  }
  async function jsonRequest(url, options, timeoutMs) {
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, timeoutMs || 15000);
    try {
      var response = await fetch(url, Object.assign({credentials: 'same-origin', cache: 'no-store'}, options || {}, {signal: controller.signal}));
      var data;
      try { data = await response.json(); } catch (e) { throw new Error('The store returned an unreadable response. Please refresh the page and check your cart.'); }
      if (!response.ok || (data && Number(data.status) >= 400)) {
        var message = data && (data.description || data.message);
        var failure = new Error(typeof message === 'string' ? message : 'The store could not process this request.');
        failure.confirmedRejection = true;
        failure.status = response.status;
        throw failure;
      }
      return data;
    } finally { clearTimeout(timeout); }
  }
  function cartMessage(text) {
    if (!errorBox) return;
    errorBox.textContent = text || '';
    errorBox.hidden = !text;
  }
  function formMessage(form, text, isError) {
    var box = form.querySelector('[data-aria-cart-message]');
    if (!box) { box = node('div'); box.dataset.ariaCartMessage = 'true'; form.append(box); }
    box.className = isError ? 'errors text-center' : 'note text-center';
    box.setAttribute('role', isError ? 'alert' : 'status');
    box.replaceChildren(document.createTextNode(text + ' '));
    var link = node('a', '', 'View cart'); link.href = route('cart'); link.dataset.ariaCartPage = 'true'; box.append(link);
  }
  function updatePrice(row, item) {
    row.replaceChildren();
    // Ajax line_price includes the discounts allocated to this line. Never
    // subtract item.discounts from an already discounted amount a second time.
    var amount = typeof item.line_price === 'number' ? item.line_price : item.final_line_price;
    if (typeof amount !== 'number') amount = Number(item.price) * item.quantity;
    var original = typeof item.original_line_price === 'number' ? item.original_line_price : Number(item.original_price || item.price) * item.quantity;
    var compareAt = compare.get(String(item.variant_id));
    var reference = Math.max(original, compareAt ? compareAt * item.quantity : 0);
    if (reference > amount) {
      row.append(node('span', 'acd-price-original', money(reference)), node('span', 'acd-price-final', money(amount)), node('span', 'acd-price-save', '(Save ' + Math.round((reference - amount) * 100 / reference) + '%)'));
    } else row.append(node('span', 'acd-price-regular', money(amount)));
  }
  function render(cart) {
    latest = cart; currency = cart.currency || 'AUD';
    var fragment = document.createDocumentFragment();
    cart.items.forEach(function (item) {
      var card = node('div', 'acd-item'); card.dataset.key = item.key;
      var url = localUrl(item.url, route('cart'));
      var photoLink = node('a', 'acd-item-img-wrap'); photoLink.href = url;
      var src = item.featured_image && item.featured_image.url || item.image;
      if (src) {
        try { var imageUrl = new URL(src, location.origin); if (imageUrl.protocol === 'https:' || imageUrl.origin === location.origin) {
          var img = node('img', 'acd-item-img'); img.src = imageUrl.href; img.alt = item.product_title || item.title || ''; img.loading = 'lazy'; photoLink.append(img);
        } } catch (e) {}
      }
      var info = node('div', 'acd-item-info');
      var title = node('a', 'acd-item-title', item.product_title || item.title); title.href = url; info.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') {
        var options = Array.isArray(item.options_with_values) ? item.options_with_values : optionMeta.get(String(item.variant_id)) || [];
        if (options.length) {
          options.forEach(function(option) {
            var rawName = String(option.name || '').replace(/\s*:\s*$/, '').trim();
            var lowerName = rawName.toLowerCase();
            var label = rawName;
            if (lowerName === 'title') return;
            if (lowerName === 'ring size') label = 'Size';
            else if (lowerName === 'select birthstone' || lowerName === 'select birthstone month') label = 'Birthstone';
            else if (lowerName.indexOf('number of names') === 0) label = 'Number of names';
            else if (lowerName.indexOf('number of initials') === 0) label = 'Number of initials';
            else if (lowerName.indexOf('number of tags') === 0) label = 'Number of tags';
            else if (lowerName === 'choose number of initials or symbols') label = 'Number of initials or symbols';
            else if (lowerName === 'initials' || lowerName === 'initial' || lowerName === 'letter') label = 'Initial';
            var row = node('p', 'acd-item-variant');
            row.append(node('strong', '', label + ': '), document.createTextNode(String(option.value || '')));
            info.append(row);
          });
        } else {
          info.append(node('p', 'acd-item-variant', item.variant_title));
        }
      }
      Object.keys(item.properties || {}).forEach(function (key) {
        var value = item.properties[key];
        if (key.charAt(0) === '_' || value === '' || value === null) return;
        var property = node('p', 'acd-item-property'); property.append(node('strong', '', key + ': '), document.createTextNode(String(value))); info.append(property);
      });
      var price = node('div', 'acd-item-price-row'); price.dataset.priceKey = item.key; updatePrice(price, item); info.append(price);
      (item.discounts || []).forEach(function (discount) { if (discount.title) info.append(node('div', 'acd-discount-badge', discount.title)); });
      var quantity = node('div', 'acd-qty-wrap');
      [['decrease', '−', 'Decrease quantity'], ['increase', '+', 'Increase quantity'], ['remove', '×', 'Remove item']].forEach(function (config, index) {
        if (index === 1) quantity.append(node('span', 'acd-qty-num', item.quantity));
        var button = node('button', config[0] === 'remove' ? 'acd-remove' : 'acd-qty-btn', config[1]);
        button.type = 'button'; button.dataset.action = config[0]; button.dataset.key = item.key; button.setAttribute('aria-label', config[2]); button.disabled = busy; quantity.append(button);
      });
      info.append(quantity); card.append(photoLink, info); fragment.append(card);
    });
    if (!cart.items.length) {
      var empty = node('div', 'acd-empty'); empty.append(node('p', '', 'Your cart is empty'));
      var link = node('a', 'acd-continue-btn', 'Continue shopping'); link.href = route('collections/all'); empty.append(link); fragment.append(empty);
    }
    items.replaceChildren(fragment);
    footer.hidden = cart.item_count === 0;
    document.getElementById('acd-subtotal').textContent = money(cart.total_price);
    document.getElementById('acd-checkout-price').textContent = money(cart.total_price);
    var shipping = document.getElementById('acd-free-au-shipping');
    var standardShipping = document.getElementById('acd-standard-au-shipping');
    var freeShippingUnlocked = currency === 'AUD' && cart.total_price > 9900;
    if (shipping) shipping.hidden = !freeShippingUnlocked;
    if (standardShipping) standardShipping.hidden = currency !== 'AUD' || freeShippingUnlocked;
    document.querySelectorAll('.cart-link__bubble-num, .cart-count, .js-cart-count, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    document.querySelectorAll('.cart-link__bubble').forEach(function (el) { el.classList.toggle('cart-link__bubble--visible', cart.item_count > 0); });
    var P = window.ARIA_PROMO || {mode: 'tiers'};
    var fill = document.getElementById('acd-progress-fill');
    var milestones = drawer.querySelectorAll('.acd-milestone');
    var label = document.getElementById('acd-progress-label');
    var wrap = drawer.querySelector('.acd-progress-wrap');
    if (wrap) wrap.hidden = P.mode === 'none';
    if (P.mode === 'bxgy') {
      var n = cart.item_count, r = n % 3, free = Math.floor(n / 3);
      var pos = ['33.33%', '66.66%', '100%'], txt = ['1', '2', '🎁'];
      milestones.forEach(function (m, i) { m.style.left = pos[i]; m.textContent = txt[i]; m.classList.toggle('reached', n > 0 && (r === 0 || r > i)); });
      if (fill) fill.style.width = (n === 0 ? 0 : r === 0 ? 100 : r / 3 * 100) + '%';
      var tag = P.label ? P.label + ': ' : '';
      if (label) {
        if (n === 0) label.textContent = tag + 'buy 2, get 1 free — the lowest-priced piece is on us.';
        else if (r === 0) label.innerHTML = '🎁 <strong>' + (free > 1 ? free + ' pieces are FREE' : 'Your lowest-priced piece is FREE') + '</strong> — applied automatically at checkout.';
        else label.innerHTML = 'Add <strong>' + (3 - r) + ' more piece' + (3 - r === 1 ? '' : 's') + '</strong>' + (free ? ' and get <strong>another piece FREE</strong>.' : ' and get the lowest-priced one <strong>FREE</strong>.');
      }
    } else if (P.mode === 'tiers') {
      if (fill) fill.style.width = Math.min(cart.item_count / 4 * 100, 100) + '%';
      [2,3,4].forEach(function (qty, i) { if (milestones[i]) milestones[i].classList.toggle('reached', cart.item_count >= qty); });
      var next = [{qty:2,percent:10},{qty:3,percent:15},{qty:4,percent:20}].find(function (t) { return cart.item_count < t.qty; });
      if (label) label.textContent = next ? 'Add ' + (next.qty - cart.item_count) + ' more item' + (next.qty - cart.item_count === 1 ? '' : 's') + ' and get EXTRA ' + next.percent + '% off!' : "You've unlocked the maximum 20% discount! It will be applied automatically at checkout.";
    }
    var checkout = drawer.querySelector('.acd-checkout-btn'); if (checkout) checkout.href = route('checkout');
  }
  function loadCompare(cart, version) {
    var handles = new Set();
    cart.items.forEach(function (item) { if (item.handle && !compare.has(String(item.variant_id))) handles.add(item.handle); });
    handles.forEach(function (handle) {
      jsonRequest(route('products/' + encodeURIComponent(handle) + '.js'), {}, 4000).then(function (product) {
        var optionNames = Array.isArray(product.options) ? product.options.map(function(option) { return typeof option === 'string' ? option : option && option.name || ''; }) : [];
        (product.variants || []).forEach(function (v) {
          compare.set(String(v.id), v.compare_at_price > v.price ? v.compare_at_price : null);
          var values = Array.isArray(v.options) ? v.options : [v.option1, v.option2, v.option3].filter(function(value) { return value !== null && value !== undefined; });
          if (optionNames.length && values.length) {
            optionMeta.set(String(v.id), optionNames.map(function(name, index) { return {name: name, value: values[index]}; }).filter(function(option) { return option.value !== undefined; }));
          }
        });
        if (revision !== version) return;
        render(cart);
      }).catch(function () { /* Optional compare-at price must not block the cart. */ });
    });
  }
  async function refresh() {
    var version = ++revision;
    var cart = await jsonRequest(route('cart.js'));
    if (!cart || !Array.isArray(cart.items) || typeof cart.total_price !== 'number') throw new Error('Unable to read the cart. Please refresh the page.');
    if (version === revision) { render(cart); loadCompare(cart, version); }
    return cart;
  }
  function startTimer() {
    var now = Date.now(), stored = 0;
    try { stored = Number(localStorage.getItem('acd_timer_end')); } catch (e) {}
    timerEnd = stored > now ? stored : timerEnd > now ? timerEnd : now + 15 * 60000;
    try { localStorage.setItem('acd_timer_end', String(timerEnd)); } catch (e) {}
    clearInterval(timer);
    function tick() {
      var left = Math.max(0, timerEnd - Date.now()), seconds = Math.floor(left / 1000);
      var element = document.getElementById('acd-timer'); if (element) element.textContent = String(Math.floor(seconds / 60)).padStart(2,'0') + ':' + String(seconds % 60).padStart(2,'0');
      var banner = document.getElementById('acd-timer-banner'); if (banner) banner.classList.toggle('acd-timer-urgent', left < 120000);
      if (!left) clearInterval(timer);
    }
    tick(); timer = setInterval(tick, 500);
  }
  function showDrawer() {
    if (!drawer.classList.contains('acd-open')) { returnFocus = document.activeElement; oldOverflow = document.body.style.overflow; }
    drawer.classList.add('acd-open'); drawer.setAttribute('aria-hidden','false'); drawer.removeAttribute('inert');
    document.body.style.overflow = 'hidden'; startTimer();
    if (closeButton) closeButton.focus();
  }
  async function open() {
    showDrawer(); cartMessage('');
    try { return await refresh(); } catch (error) { cartMessage('Unable to refresh your cart. Use View cart below or try again.'); return null; }
  }
  function close() {
    if (!drawer.classList.contains('acd-open')) return;
    drawer.classList.remove('acd-open'); drawer.setAttribute('aria-hidden','true'); drawer.setAttribute('inert','');
    document.body.style.overflow = oldOverflow; clearInterval(timer);
    if (returnFocus && returnFocus.isConnected) returnFocus.focus();
  }
  function setBusy(value) {
    busy = value; items.querySelectorAll('button').forEach(function (b) { b.disabled = value; });
    drawer.setAttribute('aria-busy', String(value));
  }
  function visibleProperty(control) {
    if (control.disabled) return false;
    var current = control.type === 'hidden' ? control.parentElement : control;
    while (current && current !== document.body) {
      var style = getComputedStyle(current); if (style.display === 'none' || style.visibility === 'hidden' || current.hidden) return false;
      current = current.parentElement;
    }
    return true;
  }
  async function submit(event) {
    var form = event.currentTarget;
    if (event.defaultPrevented) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (pending.has(form)) return;
    var button = form.querySelector('[data-add-to-cart], .add-to-cart');
    if (button && button.disabled) return;
    if (!form.checkValidity()) { form.reportValidity(); return; }
    if (busy) { formMessage(form, 'Your cart is updating. Please try again when it finishes.', true); return; }
    pending.add(form); setBusy(true); form.setAttribute('aria-busy','true');
    if (button) button.classList.add('btn--loading');
    var confirmed = false;
    try {
      var body = new FormData(form);
      // Ignore inactive personalisation slots, but preserve the native variant,
      // quantity, selling plan and all active externally-associated form fields.
      var properties = Array.from(form.elements).filter(function (c) { return c.name && c.name.indexOf('properties[') === 0; });
      // Hidden template slots can share a name with an active field. Remove the
      // default entries by name, then rebuild from active controls only.
      new Set(properties.map(function (c) { return c.name; })).forEach(function (name) { body.delete(name); });
      properties.filter(visibleProperty).forEach(function (control) {
        if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
        if (control.type === 'file') {
          Array.from(control.files || []).forEach(function (file) { body.append(control.name, file); });
        } else if (control.type === 'select-multiple') {
          Array.from(control.selectedOptions).forEach(function (option) { body.append(control.name, option.value); });
        } else body.append(control.name, control.value);
      });
      if (!body.get('id')) { var missing = new Error('Please select an available product option.'); missing.confirmedRejection = true; throw missing; }
      var result = await jsonRequest(route('cart/add.js'), {method: 'POST', body: body, headers: {'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}}, 20000);
      var added = result && Array.isArray(result.items) ? result.items[0] : result;
      if (!added || !added.id) throw new Error(uncertain);
      confirmed = true; formMessage(form, 'Added to cart.', false); cartMessage(''); showDrawer();
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail:{product:added,addToCartBtn:button}}));
      try { await refresh(); } catch (e) { cartMessage('Your item was added, but the cart display could not refresh. Open View cart below.'); }
    } catch (error) {
      var text = confirmed ? 'Your item was added. Open View cart to see it.' : error.confirmedRejection ? error.message : uncertain;
      formMessage(form, text, !confirmed);
      document.dispatchEvent(new CustomEvent('ajaxProduct:error', {detail:{errorMessage:text}}));
    } finally {
      pending.delete(form); setBusy(false); form.removeAttribute('aria-busy'); if (button) button.classList.remove('btn--loading');
    }
  }
  function bind(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9)) return;
    var forms = Array.from(root.querySelectorAll('form.product-single__form'));
    if (root.matches && root.matches('form.product-single__form')) forms.unshift(root);
    forms.forEach(function (form) {
      if (bound.has(form)) return;
      try { var u = new URL(form.action, location.href); if (u.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(u.pathname)) return; } catch (e) { return; }
      bound.add(form); form.addEventListener('submit', submit, true);
    });
  }
  items.addEventListener('click', async function (event) {
    var button = event.target.closest('button[data-action][data-key]');
    if (!button || busy || !latest) return;
    var item = latest.items.find(function (x) { return x.key === button.dataset.key; }); if (!item) return;
    var qty = button.dataset.action === 'remove' ? 0 : Math.max(0, item.quantity + (button.dataset.action === 'increase' ? 1 : -1));
    setBusy(true); cartMessage(''); ++revision;
    try {
      var cart = await jsonRequest(route('cart/change.js'), {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:item.key,quantity:qty})});
      if (!Array.isArray(cart.items)) throw new Error('Unable to read updated cart.');
      render(cart); loadCompare(cart, ++revision);
    } catch (error) {
      cartMessage(error.confirmedRejection ? error.message : 'Unable to confirm the quantity change. Please check your cart.');
      try { await refresh(); } catch (e) {}
    } finally { setBusy(false); }
  });
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var trigger = event.target.closest('.js-drawer-open-cart, [data-cart-toggle], .header__icon--cart, a[href="/cart"]');
    if (!trigger || trigger.hasAttribute('data-aria-cart-page') || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    event.preventDefault(); event.stopImmediatePropagation(); open();
  }, true);
  if (closeButton) closeButton.addEventListener('click', close);
  drawer.addEventListener('click', function (event) { if (event.target === drawer) close(); });
  document.addEventListener('keydown', function (event) {
    if (!drawer.classList.contains('acd-open')) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key !== 'Tab') return;
    var focusable = Array.from(panel.querySelectorAll('button:not(:disabled), a[href], [tabindex="0"]')).filter(function (el) { return el.getClientRects().length; });
    var first = focusable[0], last = focusable[focusable.length - 1]; if (!first) return;
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('cart:open', open);
  document.addEventListener('cart:close', close);
  document.addEventListener('cart:refresh', function () { refresh().catch(function () { cartMessage('Unable to refresh your cart.'); }); });
  bind(document);
  new MutationObserver(function (records) { records.forEach(function (r) { r.addedNodes.forEach(bind); }); }).observe(document.body,{childList:true,subtree:true});
  window.ACDCart = {version:'2026-09-19.2',open:open,close:close,refresh:refresh};
})();
